import imageUrlBuilder from '@sanity/image-url';
import myConfiguredSanityClient from '../sanityConfig';

const builder = imageUrlBuilder(myConfiguredSanityClient);

export function urlFor(source) {
  return builder.image(source);
}

export const detectMobile = {
  Android() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows() {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  any() {
    return (detectMobile.Android() || detectMobile.BlackBerry() || detectMobile.iOS() || detectMobile.Opera() || detectMobile.Windows());
  },
};

export default null;

export const pageMeta = {
  mainTitle: 'Indonesia\'s Neo-Rural Bank Pioneer',
  mainDesc: 'Komunal Group is Neo-Rural Bank Pioneer. Accelerating financial inclusion through affordable finance-related products and services',
  faqTitle: '| FAQ, Apa itu BPR? Apakah Deposito BPR aman?',
  faqDesc: 'Punya pertanyaan seputar produk dan layanan Komunal mengenai Deposito BPR? Kunjungi kami, Komunal siap membantu Anda',
  peluangTitle: '| Peluang Deposito, Temukan pilihan Deposito Anda',
  peluangDesc: 'Temukan Peluang Deposito Anda, Tenor Mulai dari 1 bulan s/d 12 bulan. Bunga Tinggi, Aman dan Proses cepat',
  loginTitle: '| Raih kebebasan finansial Anda',
  loginDesc: 'Masuk disini untuk mengajukan pembukaan Deposito BPR. Belum punya akun? Silahkan Daftar sekarang sebagai deposan untuk melanjutkan.',
  tentangTitle: '| Tentang Kami',
  tentangDesc: '| Komunal berkomitmen untuk terus memberikan pelayanan yang terbaik, aman, dan nyaman untuk Anda. Hubungi Kami segera jika mengalami kendala.',
  productsTitle: 'Our Products and Services',
  /* eslint-disable max-len */
  productsDesc: 'Our Products and Services Empowering Indonesia\'s financial inclusion through digitalization, First digitalize Rural Bank and automated loan processing Lending Platform',
  aboutTitle: 'About Us',
  aboutDesc: 'Get to know the vision, mission, and background of Komunal Group, in empowering & building MSMEs #GrowWithTheCommunity',
  communityTitle: 'Our Community',
  /* eslint-disable max-len */
  communityDesc: 'Grow by Learn, Let\'s inspire! Komunal Ambassador #K-FORCES Program. Through this program, you will gain experience & receive hands-on job exposure',
  contactTitle: 'Contact Us',
  contactDesc: 'let\'s connect with Us and be part of Komunal Group, and make Impact to Indonesia\'s Economic Growth',
};
